// =============================================
// MODELOS DE TEXTO (cuando agent_id NO contiene "image")
// =============================================
export const AI_PROVIDERS = [
  {
    name: "gemini",
    models: [
      "gemini-3.5-flash",
      "gemini-3.1-flash-lite",
    ]
  },
  {
    name: "claude",
    models: [
      "claude-opus-4-6",
      "claude-sonnet-4-6",
      "claude-haiku-4-5",
    ]
  },
  {
    name: "openai",
    models: [
      "gpt-5.1",
      "gpt-5",
      "gpt-5-mini",
      "gpt-4o",
    ]
  },
  {
    name: "deepseek",
    models: [
      "deepseek-v3.2",
      "deepseek-v3.1",
      "deepseek-r1-0528",
      "deepseek-r1",
    ]
  },
  {
    name: "mistral",
    models: [
      "mistral-medium-3.1",
      "mistral-small-3.2",
      "mistral-large-2.1",
    ]
  },
  {
    name: "llama",
    models: [
      "llama-4-maverick",
      "llama-4-scout",
      "llama-4-behemoth",
    ]
  },
  {
    name: "cohere",
    models: [
      "command-a",
      "command-a-reasoning",
      "command-r+",
    ]
  }
];

// =============================================
// MODELOS DE IMAGEN (cuando agent_id contiene "image")
// =============================================
export const AI_IMAGE_PROVIDERS = [
  {
    name: "gemini",
    models: [
      "gemini-3.1-flash-image-preview",
      "gemini-3-pro-image-preview",
    ]
  },
  {
    name: "openai",
    models: [
      "gpt-image-1",
    ]
  }
];

// =============================================
// HELPERS
// =============================================

export const getModelsByProvider = (providerName, isImageAgent = false) => {
  if (!providerName) return [];
  const providers = isImageAgent ? AI_IMAGE_PROVIDERS : AI_PROVIDERS;
  const provider = providers.find(p => p.name.toLowerCase() === providerName.toLowerCase());
  return provider ? provider.models : [];
};

export const getProviderNames = (isImageAgent = false) => {
  const providers = isImageAgent ? AI_IMAGE_PROVIDERS : AI_PROVIDERS;
  return providers.map(p => p.name);
};

// =============================================
// IMAGE CONFIGURATION CONSTANTS
// =============================================

export const IMAGE_DIMENSIONS = [
  { resolution: "1024x1024", type: "square" },
  { resolution: "1536x1024", type: "landscape" },
  { resolution: "1024x1536", type: "portrait" }
];

export const GEMINI_ASPECT_RATIOS = [
  "1:1",
  "2:3",
  "3:2",
  "3:4",
  "4:3",
  "4:5",
  "5:4",
  "9:16",
  "16:9",
  "21:9"
];

export const GEMINI_IMAGE_SIZES = [
  "1k",
  "2k",
  "4k"
];

export const shouldShowImageDimensions = (agentId) => {
  return agentId && agentId.toLowerCase().includes('image');
};

export const getImageFieldsConfig = (agentId, providerAi) => {
  const isImageAgent = shouldShowImageDimensions(agentId);

  if (!isImageAgent) {
    return { showFields: false, provider: null };
  }

  const provider = providerAi?.toLowerCase();

  if (provider === 'openai') {
    return { showFields: true, provider: 'openai' };
  }

  if (provider === 'gemini') {
    return { showFields: true, provider: 'gemini' };
  }

  return { showFields: false, provider: null };
};

// =============================================
// DEFAULT FALLBACK CONFIGURATIONS
// =============================================

export const DEFAULT_TEXT_FALLBACK = {
  max_retries: 1,
  primary_fallback_provider: "gemini",
  primary_fallback_model: "gemini-3.5-flash",
  secondary_fallback_provider: "claude",
  secondary_fallback_model: "claude-sonnet-4-6",
};

export const DEFAULT_IMAGE_FALLBACK = {
  image_max_retries: 5,
  image_retry_delay_after: 3,
  image_retry_delay_seconds: 5,
  image_fallback_provider: "openai",
  image_fallback_model: "gpt-image-1",
};
